import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Form as BootstrapForm } from 'react-bootstrap';
import FormField from '../layout/FormField';
import FormSelect from '../layout/FormSelect';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Link, useNavigate } from 'react-router-dom';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { toast } from 'react-toastify';
import { useAuth } from '../../hooks/useAuth';
import { validateFileType } from '../../helpers/utils';
import ReactSelect from 'react-select';
import AddressInputWithMapClick from '../Modals/VendorModals/AddressInputWithMapClick.jsx';

const AddVendors = () => {
    const [status, setStatus] = useState('active');
    const [vendorType, setVendorType] = useState('retail');
    const [vendorLogo, setVendorLogo] = useState('');
    const validate = Yup.object({
        vendor_name: Yup.string().required('Required'),
        vendor_email: Yup.string().email('Email is invalid').required('Required'),
        vendor_phone: Yup.string()
            .matches(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4,5}$/, "Your phone number format must be '+1 233-343-2342'")
            .required('Required'),
        vendor_website: Yup.string().matches(
            /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
            'Please enter a valid website url!'
        ),
        transit_agency: Yup.array().min(1, 'At least one transit agency is required').required('Required')
    });
    const { getToken, user } = useAuth();
    const navigate = useNavigate();
    const [isValidSelected, setIsValidSelected] = useState(false);
    const [transitAgencyOptions, setTransitAgencyOptions] = useState([]);
    const [transitAgency, setTransitAgency] = useState([]);
    const [vendorNames, setVendorNames] = useState([]);

    const getTransitAgencies = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getAllAgencies(token, '', '', '', 'active', '')
                .then((res) => {
                    if (res?.code == 200) {
                        setTransitAgencyOptions((state) => {
                            const s = res?.data?.agencies?.map((item) => ({ value: item._id, label: item?.name }));
                            return s;
                        });
                    }
                })
                .catch((err) => {});
        }
    };

    const fetchVendors = async () => {
        const token = getToken();
        if (!token) return;

        const webApiCalls = new WebApiCalls();
        let pageNo = 1;
        const pageSize = 50;
        let allNames = [];

        try {
            while (true) {
                const res = await webApiCalls.getAllVendors(token, pageSize, pageNo);

                if (res?.code === 200) {
                    const vendors = res?.data?.vendors || [];
                    if (vendors?.length === 0) break;

                    allNames.push(...vendors?.map((v) => v.name.toLowerCase()));

                    if (vendors?.length < pageSize) break;

                    pageNo++;
                } else {
                    console.error('Error fetching vendors:', res?.message);
                    break;
                }
            }
            setVendorNames(allNames);
        } catch (error) {
            console.error('Error fetching vendors:', error);
        }
    };

    useEffect(() => {
        getTransitAgencies();
        fetchVendors();
    }, []);

    const validateForm = () => {
        let isValid = true;
        return isValid;
    };

    const handleSubmit = async (values, actions) => {
        const token = getToken();
        if (!token) return;

        if (vendorNames.includes(values.vendor_name.toLowerCase())) {
            toast.error('Vendor name already exists!');
            return;
        }

        if (validateForm()) {
            const transitAgencies = values.transit_agency?.map((item) => item.value);
            const obj = {
                ...values,
                user: user._id,
                status,
                role: 'vendor',
                password: '12345678',
                name: values?.vendor_name,
                email: values?.vendor_email,
                vendor_type: vendorType,
                vendor_website: values?.vendor_website,
                transit_agency: transitAgencies,
                lat: values?.location?.lat,
                long: values?.location?.lng
            };

            const webApiCalls = new WebApiCalls();
            if (vendorLogo) {
                const data = new FormData();
                data.append('image', vendorLogo);
                webApiCalls
                    .uploadImages(token, data)
                    .then((res) => {
                        if (res?.code == 200) {
                            obj.vendor_logo = res?.data?.URL;

                            const webApiCalls = new WebApiCalls();
                            webApiCalls
                                .createVendor(token, obj)
                                .then((res) => {
                                    if (res && res?.code == 200) {
                                        toast.success('Vendor has been added successfully.');
                                        navigate('/vendors');
                                    } else {
                                        toast.error(res.message);
                                    }
                                })
                                .catch((err) => {
                                    console.log(err);
                                });
                        } else {
                            return null;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                if (!isValidSelected) {
                    toast.error('Please select a valid image format');
                    return;
                }
                toast.error('Please select a logo image');
            }
        }
    };

    return (
        <>
            <Row className="d-flex justify-content-center ">
                <Col xs={12} sm={12} md={11} lg={11} className="shadow-lg p-5 m-3">
                    <Formik
                        initialValues={{
                            transit_agency: [],
                            vendor_name: '',
                            vendor_email: '',
                            vendor_phone: '',
                            vendor_website: '',
                            vendor_type: '',
                            vendor_logo: '',
                            location: { lat: '', lng: '' }
                        }}
                        validationSchema={validate}
                        onSubmit={handleSubmit}
                        enableReinitialize={true}
                    >
                        {(formik) => (
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    formik.handleSubmit();
                                }}
                            >
                                <Row>
                                    <Col xs={6} sm={6} md={6} lg={6} className="mb-2">
                                        <BootstrapForm.Group>
                                            <BootstrapForm.Label>Transit Agency</BootstrapForm.Label>
                                            <ReactSelect
                                                options={transitAgencyOptions}
                                                value={formik.values.transit_agency}
                                                onChange={(selectedOptions) => formik.setFieldValue('transit_agency', selectedOptions || [])}
                                                placeholder="Select transit agency"
                                                name="transit_agency"
                                                isMulti={true}
                                                isClearable={true}
                                            />
                                            {formik.errors.transit_agency && <div className="text-danger">{formik.errors.transit_agency}</div>}
                                        </BootstrapForm.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <FormField
                                            className="form-control common-input"
                                            label="Name"
                                            name="vendor_name"
                                            type="text"
                                            placeholder="Enter name"
                                            onChange={formik.handleChange}
                                            value={formik.values.vendor_name}
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={11} lg={6} className="mb-2">
                                        <FormField
                                            className="form-control common-input"
                                            label="Email"
                                            name="vendor_email"
                                            type="email"
                                            placeholder="Enter Email"
                                            onChange={formik.handleChange}
                                            value={formik.values?.vendor_email}
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <label htmlFor="transit_type">Status</label>
                                        <select value={status} onChange={(e) => setStatus(e.target.value)} name="transit_type" className="common-selector">
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                    </Col>
                                    <Col xs={12} sm={12} md={11} lg={6} className="mb-2">
                                        <FormField
                                            className="form-control common-input"
                                            onKeyDown={(e) => {
                                                if (e.target.value.length === 0 && e.key !== 'Backspace') {
                                                    e.target.value = '+' + e.target.value;
                                                }
                                                if (e.target.value.length === 2 && e.key !== 'Backspace') {
                                                    e.target.value = e.target.value + ' ';
                                                }
                                                if (e.target.value.length === 6 && e.key !== 'Backspace') {
                                                    e.target.value = e.target.value + '-';
                                                }
                                                if (e.target.value.length === 10 && e.key !== 'Backspace') {
                                                    e.target.value = e.target.value + '-';
                                                }
                                                formik.setFieldValue('vendor_phone', e.target.value);
                                            }}
                                            label="Vendor Phone"
                                            name="vendor_phone"
                                            type="text"
                                            placeholder="Enter phone"
                                            value={formik.values?.vendor_phone}
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <label htmlFor="vendor_type">Vendor Type</label>
                                        <select value={vendorType} onChange={(e) => setVendorType(e.target.value)} name="vendor_type" className="common-selector">
                                            <option value="retail">Retail</option>
                                            <option value="health">Health</option>
                                            <option value="wellness">Wellness</option>
                                        </select>
                                    </Col>
                                    <Col xs={12} sm={12} md={11} lg={6} className="mb-2">
                                        <FormField
                                            className="form-control common-input"
                                            label="Vendor Website(url)"
                                            name="vendor_website"
                                            type="text"
                                            placeholder="Enter Vendor Website"
                                            onChange={formik.handleChange}
                                            value={formik.values?.vendor_website}
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                        <BootstrapForm.Group>
                                            <BootstrapForm.Label className="mb-0">Vendor Logo</BootstrapForm.Label>
                                            <BootstrapForm.Control
                                                type="file"
                                                className="form-control common-input"
                                                onChange={(e) => {
                                                    const { name } = e.target.files[0];
                                                    if (validateFileType(name)) {
                                                        setVendorLogo(e.target.files[0]);
                                                        setIsValidSelected(true);
                                                        return;
                                                    }
                                                    setIsValidSelected(false);
                                                    toast.error('File format is not supported!');
                                                }}
                                                name="uploadPicture"
                                            />
                                        </BootstrapForm.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} className="mb-3">
                                        <div className="config-form-container px-0">
                                            <label className="config-legend-label">Location</label>
                                            <AddressInputWithMapClick
                                                errors={formik.errors}
                                                values={formik.values}
                                                setFieldValue={formik.setFieldValue}
                                                label="Vendor Address"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <div className="text-end">
                                    <Link to="/vendors">
                                        <Button type="submit" className="theme-cancel-btn me-3">
                                            Cancel
                                        </Button>
                                    </Link>
                                    <Button type="submit" className="theme-btn">
                                        Save
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Col>
            </Row>
        </>
    );
};
export default AddVendors;
